import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { RiSpam2Line } from '@remixicon/react';
import { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useStream } from '../../contexts/GetStream/StreamContext';
import { sentryCapture } from '../../helpers/utils';
import { useApi } from '../../hooks/useApi';
import { useFeedUpdateStore } from '../../store/feedUpdate';
import { SentryError } from '../../types/enums';
import { FilterModality } from '../Filters/FilterModality';
import FeedPickItem from './item';

const FeedPick = () => {
	const api = useApi();
	const { updateFeed, updateFeedFinish } = useStream();
	const { feedupdate, finishUpdateFeed } = useFeedUpdateStore();
	const [isLoading, setIsLoading] = useState<any>(false);
	const [isLoadingFeed, setIsLoadingFeed] = useState<any>(false);
	const [feeds, setFeeds] = useState<any[]>([]);
	const [modality, setModality] = useState<any>([]);

	const [filters, setFilters] = useState<any>({
		modality: 'Futebol',
	});

	useEffect(() => {
		fetchModality();
		fetchFeed(filters);
	}, []);

	useEffect(() => {
		if (updateFeed || feedupdate) {
			fetchFeed(filters);
		}
	}, [updateFeed, feedupdate]);

	useEffect(() => {
		if (filters) {
			fetchFeed(filters);
		}
	}, [filters]);

	useEffect(() => {
		if (Capacitor.isNativePlatform()) {
			const setupListener = async () => {
				const handle = await App.addListener(
					'appStateChange',
					(appState) => {
						if (appState.isActive) {
							updateFetchFeedBack(filters);
						}
					}
				);
				return handle;
			};

			const listenerPromise = setupListener();
			return () => {
				listenerPromise.then((handle) => handle.remove());
			};
		}
	}, [App]);

	const fetchFeed = async (filters: any) => {
		setIsLoadingFeed(true);
		try {
			const res = await api.getFeedPick(filters);
			if (!res?.success) {
				throw new Error(res.message);
			}
			setFeeds(res.data);
			finishUpdateFeed();
		} catch (error: any) {
			sentryCapture(error, 'fetchFeed', SentryError.Error);
		} finally {
			setIsLoadingFeed(false);
			updateFeedFinish();
		}
	};
	const updateFetchFeedBack = async (filters: any) => {
		try {
			const res = await api.getFeedPick(filters);
			if (!res?.success) {
				throw new Error(res.message);
			}
			setFeeds(res.data);
			finishUpdateFeed();
		} catch (error: any) {
			sentryCapture(error, 'fetchFeed', SentryError.Error);
		} finally {
			updateFeedFinish();
		}
	};

	const fetchModality = async () => {
		setIsLoading(true);
		try {
			const res = await api.getModalityPick();
			if (!res?.success) {
				throw new Error(res.message);
			}
			setModality(res.data);
		} catch (error: any) {
			sentryCapture(error, 'fetchFeed', SentryError.Error);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<div className="w-full flex flex-col">
			<FilterModality
				filters={filters}
				setFilters={setFilters}
				modality={modality}
				loading={isLoading || isLoadingFeed}
			/>
			{isLoadingFeed ? (
				<div className="p-3">
					<Skeleton className="w-full h-[543px] rounded-lg" />
				</div>
			) : feeds.length > 0 ? (
				<FeedPickItem item={feeds} isLoading={isLoadingFeed} />
			) : (
				<div className="p-3 text-text/heading-default text-base flex flex-col justify-center items-center text-center font-normal font-bahnschrift leading-[16px]">
					<RiSpam2Line className="text-custom-gray3/30 w-36 h-36" />
					No momento, não há picks disponíveis para esta modalidade.
				</div>
			)}
		</div>
	);
};

export default FeedPick;
